import { render } from "./FeaturesView.vue?vue&type=template&id=bc4e90a2&scoped=true"
import script from "./FeaturesView.vue?vue&type=script&lang=js"
export * from "./FeaturesView.vue?vue&type=script&lang=js"

import "./FeaturesView.vue?vue&type=style&index=0&id=bc4e90a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4e90a2"]])

export default __exports__